import {
  GRAPH_MODAL_REQUEST,
  GRAPH_MODAL_REQUEST_SUCCESS,
  GRAPH_MODAL_REQUEST_ERROR,
} from "./actionTypes"


export const graphModalRequest = data => ({
  type: GRAPH_MODAL_REQUEST,
  payload: data
});

export const graphModalRequestSuccess = data => ({
  type: GRAPH_MODAL_REQUEST_SUCCESS,
  payload: {data}
});

export const graphModalRequestError = error => ({
  type: GRAPH_MODAL_REQUEST_ERROR,
  payload: error,
});
